<template>
  <tr
    v-if="!isEditing && estimationRole.id"
    :class="{ shadow: estimationRole.role === 'Shadow' }"
  >
    <td
      v-for="(header, index) in headers.filter((h) => !h.hidden)"
      :key="index"
    >
      <template v-if="header.value === 'estimationRole.name'">
        {{ estimationRole.name }}
      </template>
      <template v-if="header.value === 'estimationRole.description'">
        {{ estimationRole.description }}
      </template>
      <template v-else-if="header.value === 'estimationRole.salary'">
        {{ estimationRole.salary }}
      </template>
      <template
        v-else-if="header.value === 'estimationRole.rate'"
      >
        {{ estimationRole.rate }}
      </template>
      <template
        v-else-if="header.value === 'estimationRole.overhead'"
      >
        {{ estimationRole.overhead }}
      </template>
    </td>
    <td v-if="allowed">
      <template v-if="!isEditing">
        <v-row>
          <v-btn
            text
            icon
            small
            @click.stop="editEstimationRole()"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            text
            icon
            small
            @click.stop="deleteEstimationRole(estimationRole)"
          >
            <v-icon>delete_outline</v-icon>
          </v-btn>
        </v-row>
      </template>
    </td>
  </tr>
  <ProjectEstimationRoleInput
    v-else
    :key="estimationRole.id"
    :estimation-role="estimationRole"
    :headers="headers"
    @save="saveEstimateRole"
    @cancel="cancelEdit"
  />
</template>

<script>
import { mapGetters } from 'vuex';

import ProjectEstimationRoleInput from '@/components/projects/ProjectEstimationRoleInput.vue';
import { loadingTypes } from '@/constants/loadingTypes';
import { DateHelper } from '@/helpers/date.helper';

export default {
  name: 'ProjectEstimateRoleRow',
  components: {
    ProjectEstimationRoleInput,
  },
  filters: {
    dateToDisplay: DateHelper.formatDateAccordingSettings,
  },
  props: {
    selected: {
      type: Boolean,
      required: true,
    },
    select: {
      type: Function,
      required: true,
    },
    estimationRole: {
      type: Object,
      required: true,
    },
    headers: {
      type: Array,
      required: true,
    },
    allowed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      allowedToUpdateProjectEmployee: false,
      allowedToUpdateProjectTaskTypes: false,
      loadingTypes,
      isLoading: false,
      syncProjectText: 'Sync',
      isEditing: false,
    };
  },
  computed: {
    ...mapGetters('shared/offices', ['offices']),
    ...mapGetters('user/settings', [
      'denseTables',
      'dateFormatSettings',
    ]),
  },
  mounted() {},
  methods: {
    cancelEdit() {
      this.setEditing(false);
    },
    saveEstimateRole(role) {
      this.$emit('onSave', role);
      this.cancelEdit();
    },
    deleteEstimationRole(item) {
      this.$emit('onDelete', item);
    },
    selectItem() {
      this.$emit('onSelect', this.assignment);
    },
    setEditing(value) {
      this.isEditing = value;
    },
    editEstimationRole() {
      this.setEditing(true);
    },
  },
};
</script>

<style lang="less">
@import "~variables";

.row-editor {
  .project-input {
    max-width: 270px;
  }

  .v-label {
    font-size: @table-font-size;
  }

  .v-text-field__slot {
    font-size: @table-font-size;
  }

  .v-text-field {
    input {
      font-size: @table-font-size;
    }
  }

  .clipped div.v-select__selection {
    overflow: hidden;
    white-space: nowrap;
  }

  // Validation error message
  .v-input {
    .v-text-field__details {
      overflow: visible;
    }

    .v-messages__message {
      position: absolute;
      background: @soft-peach;
      border: 1px solid @pink;
      border-radius: 0 2px 2px 2px;
      width: max-content;
      max-width: 120px;
      padding: 3px;
      color: @red-dark;
      box-shadow: 0 -1px 8px 2px @pink-light;

      &::before {
        content: "";
        position: absolute;
        border: solid transparent;
        border-width: 0 6px 5px 0;
        border-bottom-color: @pink;
        top: -5px;
        left: -1px;
      }
    }
  }
  .time__cell {
    position: relative;
  }
}
</style>
